import { ProjectPerspective } from "@app/projects";

export const getProjectPerspectiveFromFilterString = (filter: string): ProjectPerspective => {
  switch (filter) {
    case "State":
      return ProjectPerspective.ByState;
    case "County":
      return ProjectPerspective.ByCounty;
    case "Specialty":
      return ProjectPerspective.BySpecialty;
    case "Inspection":
      return ProjectPerspective.ByInspection;
    case "All":
      return ProjectPerspective.All;
    default:
      return ProjectPerspective.ByState;
  }
}

export const getProjectPerspectiveDescription = (projectPerspective: ProjectPerspective) : string => {
  switch (projectPerspective) {
    case ProjectPerspective.All:
      return "All";
    case ProjectPerspective.ByInspection:
      return "Inspection";
    case ProjectPerspective.ByState:
      return "State";
    case ProjectPerspective.ByCounty:
      return "County";
    case ProjectPerspective.BySpecialty:
      return "Specialty";
  }
}
